var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 420.28,
  height: 201.68,
  viewBox: "0 0 420.28 201.68"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.215 -0.038)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,109.58H114.572V0H0Z",
  transform: "translate(326.142 22.895) rotate(90)",
  fill: "rgba(163,177,191,0.25)",
  opacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,109.58H114.572V0H0Z",
  transform: "translate(326.142 22.895) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.294,29.193A8.335,8.335,0,0,1,0,20.866V8.327A8.335,8.335,0,0,1,8.294,0H125.783a8.335,8.335,0,0,1,8.294,8.327V20.866a8.335,8.335,0,0,1-8.294,8.327Z",
  transform: "translate(349.394 13.19) rotate(90)",
  fill: "#f0f2f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.294,29.193A8.335,8.335,0,0,1,0,20.866V8.327A8.335,8.335,0,0,1,8.294,0H125.783a8.335,8.335,0,0,1,8.294,8.327V20.866a8.335,8.335,0,0,1-8.294,8.327Z",
  transform: "translate(349.394 13.19) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.009,39.877a1.491,1.491,0,1,1-1.491-1.5,1.494,1.494,0,0,1,1.491,1.5L7.278,13.386,0,0",
  transform: "translate(381.774 0.038) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(343.454 21.097) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(343.454 30.021) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(343.454 30.021) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(343.454 38.944) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(343.454 38.944) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(343.454 47.868) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(343.454 47.868) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(343.454 56.792) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(343.454 56.792) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(343.454 65.716) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(343.454 65.716) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.492,2.993A1.5,1.5,0,1,1,2.983,1.5,1.494,1.494,0,0,1,1.492,2.993Z",
  transform: "translate(328.897 21.097) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(328.897 21.097) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(328.897 30.021) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(328.897 30.021) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(328.897 38.944) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(328.897 38.944) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(328.897 47.868) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(328.897 47.868) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(328.897 56.792) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(328.897 56.792) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(328.897 65.716) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(328.897 65.716) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.492,2.993A1.5,1.5,0,1,1,2.983,1.5,1.494,1.494,0,0,1,1.492,2.993Z",
  transform: "translate(336.176 25.153) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(336.176 25.153) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(336.176 34.077) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(336.176 34.077) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(336.176 43.001) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(336.176 43.001) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(336.176 51.924) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(336.176 51.924) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(336.176 60.848) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(336.176 60.848) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(336.176 69.772) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(336.176 69.772) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.326,8.685A4.342,4.342,0,1,1,8.651,4.342,4.334,4.334,0,0,1,4.326,8.685Z",
  transform: "translate(339.432 127.379) rotate(90)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(307.871 120.069) rotate(90)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(307.871 120.069) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(294.123 120.069) rotate(90)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(294.123 120.069) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(307.871 37.322) rotate(90)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(307.871 37.322) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(294.123 37.322) rotate(90)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(294.123 37.322) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.294,29.193A8.335,8.335,0,0,1,0,20.866V8.327A8.335,8.335,0,0,1,8.294,0H125.783a8.335,8.335,0,0,1,8.294,8.327V20.866a8.335,8.335,0,0,1-8.294,8.327Z",
  transform: "translate(279.037 13.19) rotate(90)",
  fill: "#f0f2f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.294,29.193A8.335,8.335,0,0,1,0,20.866V8.327A8.335,8.335,0,0,1,8.294,0H125.783a8.335,8.335,0,0,1,8.294,8.327V20.866a8.335,8.335,0,0,1-8.294,8.327Z",
  transform: "translate(279.037 13.19) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(273.096 21.097) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(273.096 21.097) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(273.096 30.021) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(273.096 30.021) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(273.096 38.944) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(273.096 38.944) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(273.096 47.868) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(273.096 47.868) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(273.096 56.792) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(273.096 56.792) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.492,2.993A1.5,1.5,0,1,1,2.983,1.5,1.494,1.494,0,0,1,1.492,2.993Z",
  transform: "translate(273.096 65.716) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(273.096 65.716) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(258.54 21.097) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(258.54 21.097) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(258.54 30.021) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(258.54 30.021) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(258.54 38.944) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(258.54 38.944) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(258.54 47.868) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(258.54 47.868) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(258.54 56.792) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(258.54 56.792) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(258.54 65.716) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(258.54 65.716) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(265.818 25.153) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(265.818 25.153) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(265.818 34.077) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(265.818 34.077) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(265.818 43.001) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(265.818 43.001) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(265.818 51.924) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(265.818 51.924) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(265.818 60.848) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(265.818 60.848) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(265.818 69.772) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(265.818 69.772) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.326,8.685A4.342,4.342,0,1,1,8.651,4.342,4.334,4.334,0,0,1,4.326,8.685Z",
  transform: "translate(268.266 127.379) rotate(90)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.294,29.193A8.335,8.335,0,0,1,0,20.866V8.327A8.335,8.335,0,0,1,8.294,0H125.783a8.335,8.335,0,0,1,8.294,8.327V20.866a8.335,8.335,0,0,1-8.294,8.327Z",
  transform: "translate(243.454 13.19) rotate(90)",
  fill: "#f0f2f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.294,29.193A8.335,8.335,0,0,1,0,20.866V8.327A8.335,8.335,0,0,1,8.294,0H125.783a8.335,8.335,0,0,1,8.294,8.327V20.866a8.335,8.335,0,0,1-8.294,8.327Z",
  transform: "translate(243.454 13.19) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(237.513 21.097) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(237.513 21.097) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(237.513 30.021) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(237.513 30.021) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(237.513 38.944) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(237.513 38.944) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(237.513 47.868) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(237.513 47.868) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(237.513 56.792) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(237.513 56.792) rotate(90)",
  fill: "none",
  stroke: "rgba(163,177,191,0.85)",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(237.513 65.716) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(237.513 65.716) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(223.765 21.097) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(223.765 21.097) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(223.765 30.021) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(223.765 30.021) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(223.765 38.944) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(223.765 38.944) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(223.765 47.868) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(223.765 47.868) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(223.765 56.792) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(223.765 56.792) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(223.765 65.716) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(223.765 65.716) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(230.235 25.153) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(230.235 25.153) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(230.235 34.077) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(230.235 34.077) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(230.235 43.001) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(230.235 43.001) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(230.235 51.924) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(230.235 51.924) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(230.235 60.848) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(230.235 60.848) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5",
  transform: "translate(230.235 69.772) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.983,1.5A1.491,1.491,0,1,1,1.492,0,1.494,1.494,0,0,1,2.983,1.5Z",
  transform: "translate(230.235 69.772) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.651,4.342A4.326,4.326,0,1,1,4.326,0,4.334,4.334,0,0,1,8.651,4.342H1.986",
  transform: "translate(233.491 127.379) rotate(90)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.4,60.395.429,48.507A8.359,8.359,0,0,1,5.654,37.964L45.8,24.434l71.231-24a8.311,8.311,0,0,1,10.5,5.244l3.975,11.887a8.358,8.358,0,0,1-5.224,10.544L14.907,65.639A8.312,8.312,0,0,1,4.4,60.395Z",
  transform: "translate(211.533 15.621) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.966,2.917a1.5,1.5,0,1,1,.939-1.9A1.489,1.489,0,0,1,1.966,2.917Z",
  transform: "translate(172.01 34.077) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.966,2.917a1.5,1.5,0,1,1,.939-1.9A1.489,1.489,0,0,1,1.966,2.917Z",
  transform: "translate(172.01 34.077) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(174.436 43.001) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.966,2.917a1.5,1.5,0,1,1,.939-1.9A1.489,1.489,0,0,1,1.966,2.917Z",
  transform: "translate(174.436 43.001) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(177.671 51.113) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.966,2.917a1.5,1.5,0,1,1,.939-1.9A1.489,1.489,0,0,1,1.966,2.917Z",
  transform: "translate(177.671 51.113) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(180.097 60.037) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(180.097 60.037) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(183.332 68.149) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(183.332 68.149) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(185.758 77.073) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(185.758 77.073) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(168.775 38.944) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.966,2.917a1.5,1.5,0,1,1,.939-1.9A1.489,1.489,0,0,1,1.966,2.917Z",
  transform: "translate(157.985 38.944) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(171.201 47.057) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(160.411 47.057) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(174.436 55.981) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(163.646 55.981) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(166.349 64.093) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(166.349 64.093) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(169.584 73.017) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(169.584 73.017) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(172.819 81.129) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(172.819 81.129) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(166.349 40.567) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(166.349 40.567) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(169.584 49.491) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(169.584 49.491) rotate(90)",
  fill: "none",
  stroke: "rgba(163,177,191,0.85)",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(172.01 57.603) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(172.01 57.603) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(175.245 66.527) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(175.245 66.527) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(177.671 74.639) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(177.671 74.639) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943",
  transform: "translate(180.906 83.563) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.905,1.021A1.492,1.492,0,1,1,1.017.078a1.5,1.5,0,0,1,1.888.943Z",
  transform: "translate(180.906 83.563) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.427,2.962A4.327,4.327,0,1,1,2.95.227,4.347,4.347,0,0,1,8.427,2.962",
  transform: "translate(199.529 127.379) rotate(90)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.511,5.252,0,2.626,1.511,0h3.02L6.041,2.626,4.531,5.252Z",
  transform: "translate(196.907 9.744) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.511,5.252,0,2.626,1.511,0h3.02L6.041,2.626,4.531,5.252Z",
  transform: "translate(266.456 190.652) rotate(90)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.511,5.252,0,2.626,1.511,0h3.02L6.041,2.626,4.531,5.252Z",
  transform: "translate(266.456 190.652) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,2.626,1.511,0h3.02L6.041,2.626,4.531,5.252H1.511Z",
  transform: "translate(202.568 42.194) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,2.626,1.511,0h3.02L6.041,2.626,4.531,5.252H1.511Z",
  transform: "translate(205.803 32.459) rotate(90)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,.811H380.092",
  transform: "translate(28.709 148.863)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 2.43
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.432,0H380.092S319.843,47.052,245.847,44.213,147.589,29.2,128.989,22.3s-55.37-9.722-80.881-4.043S0,0,0,0Z",
  transform: "translate(28.305 157.382)",
  fill: "rgba(163,177,191,0.25)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 75.851)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.583,
  cy: 35.695,
  rx: 35.583,
  ry: 35.695,
  transform: "translate(0 0)",
  fill: "rgba(163,177,191,0.25)",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 2.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.461,
  cy: 30.557,
  rx: 30.461,
  ry: 30.557,
  transform: "translate(5.391 5.408)",
  fill: "#f0f2f5"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,0,38.818,11.357",
  transform: "translate(39.627 107.896)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("path", {
  d: "M.4.406,33.561,25.554",
  transform: "translate(66.314 141.157) rotate(-180)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.477 46.403) rotate(19)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.3,17.657A8.587,8.587,0,0,1,0,8.828,8.587,8.587,0,0,1,8.3,0a8.587,8.587,0,0,1,8.3,8.828A8.588,8.588,0,0,1,8.3,17.657Zm0-14.933a5.937,5.937,0,0,0-5.74,6.1q0,.088,0,.175A6.257,6.257,0,0,0,4.3,13.2a5.482,5.482,0,0,0,7.75.25,6.222,6.222,0,0,0,1.924-3.671,6.53,6.53,0,0,0,.07-.951A5.938,5.938,0,0,0,8.3,2.724Z",
  transform: "translate(40.191 63.628)",
  fill: "rgba(163,177,191,0.4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.667,26.941C5.682,26.941,0,20.9,0,13.47S5.682,0,12.667,0,25.334,6.043,25.334,13.47,19.651,26.941,12.667,26.941Zm0-24.216C7.095,2.724,2.561,7.545,2.561,13.47S7.095,24.216,12.667,24.216,22.772,19.4,22.772,13.47,18.239,2.724,12.667,2.724Z",
  transform: "translate(35.338 58.761)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.539,12.169A5.838,5.838,0,0,1,0,6.084,5.837,5.837,0,0,1,5.539,0a5.837,5.837,0,0,1,5.538,6.084A5.837,5.837,0,0,1,5.539,12.169Zm0-10.939A4.657,4.657,0,0,0,1.12,6.084a4.657,4.657,0,0,0,4.419,4.854A4.657,4.657,0,0,0,9.957,6.084,4.657,4.657,0,0,0,5.539,1.23Z",
  transform: "translate(0.688 60.074)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.037,74.209h0l-1.954-2.134a1.752,1.752,0,0,1-1.71,1.124H42.35L1.55,69.161A1.717,1.717,0,0,1,.123,68.027a1.9,1.9,0,0,1,.3-1.868L33.2,26.061,31.16,13.721a1.834,1.834,0,0,1,1.183-2.239,1.616,1.616,0,0,1,.463-.068,1.731,1.731,0,0,1,1.642,1.326l2.062,12.424,49.106-5.117L79.13,3.567a2.7,2.7,0,0,1,.218-2.419A2.379,2.379,0,0,1,81.362,0H93.554a2.5,2.5,0,0,1,2.419,2.573,2.5,2.5,0,0,1-2.419,2.572h-1.8V10.99h12.634l7.986-8.77a1.393,1.393,0,0,1,1.023-.46,1.339,1.339,0,0,1,.563.124,7.261,7.261,0,0,1,3.8,5.182c.725,4.02-1.606,8.929-6.928,14.589a1.364,1.364,0,0,1-2.013,0,1.583,1.583,0,0,1,0-2.14c5.717-6.08,6.5-9.793,6.153-11.837a4.241,4.241,0,0,0-1.363-2.465l-7.6,8.344a1.389,1.389,0,0,1-1.022.461H90.328A1.472,1.472,0,0,1,88.9,12.5V5.145H85l23.694,60.2a2.638,2.638,0,0,1-1.3,3.366,2.286,2.286,0,0,1-.933.2,2.419,2.419,0,0,1-2.234-1.58L89.313,29.442ZM84.1,23.853,35.381,28.931,5.181,65.871l36.535,3.614-.841-.918Z",
  transform: "translate(3.799 0.223)",
  fill: "#a3b1bf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.83,0S0,0,0,1.217,10.918,11.357,10.918,11.357Z",
  transform: "translate(117.262 133.044)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.087,0s2.83,0,2.83,1.217S0,11.357,0,11.357Z",
  transform: "translate(138.289 133.044)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.222,0S-.4,1.06.053,2.189,13.974,7.5,13.974,7.5Z",
  transform: "translate(112.7 137.687)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.74,0s2.624,1.063,2.17,2.192S0,7.492,0,7.492Z",
  transform: "translate(138.288 138.517)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5.667C5.072.309.468-1,.029,1.478-.327,3.492,2.61,9.493,5.69,10.4c6.874,2.028,14.557-.811,21.431,1.217S33.6,10,32.378,8.779C29.952,6.345,9.734,1.478,6.5.667Z",
  transform: "translate(67.902 58.96)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 2.43
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(346.684 76.257)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.583,
  cy: 35.695,
  rx: 35.583,
  ry: 35.695,
  transform: "translate(0 0)",
  fill: "#dce1e7",
  stroke: "#a3b1bf",
  strokeMiterlimit: 10,
  strokeWidth: 2.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.461,
  cy: 30.557,
  rx: 30.461,
  ry: 30.557,
  transform: "translate(5.391 5.408)",
  fill: "#f0f2f5"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.262,0C6.928.748,5.291,2.594,3.774,6.146a46.263,46.263,0,0,0-3.639,21.5S1.752,8.174,8.222,4.524",
  transform: "translate(356.639 93.293)",
  fill: "#a3b1bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.262,0C6.928.748,5.291,2.594,3.774,6.146a46.263,46.263,0,0,0-3.639,21.5S1.752,8.174,8.222,4.524",
  transform: "translate(408.396 131.483) rotate(-180)",
  fill: "#a3b1bf"
}))));
export default __webpack_public_path__ + "static/media/500.5ca8d2c1.svg";
export { SvgComponent as ReactComponent };